import Typography  from '@mui/material/Typography';
import Box  from '@mui/material/Box';
import { SxProps, Theme, styled } from '@mui/system';
import React from 'react';

interface MarqueeProps {
  speed?: number;
  text: string;
  typographyStyle?: SxProps<Theme>;
}

const MarqueeContainer = styled(Box)({
  overflow: 'hidden',
  position: 'relative',
  whiteSpace: 'nowrap',
  width: '100%',
});

const MarqueeText = styled(Box)<{ speed: number }>(({ speed }) => ({
  '@keyframes marqueeAnimation': {
    '0%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(-100%)',
    },
  },
  animation: `marqueeAnimation ${speed}s linear infinite`,
  display: 'inline-block',
  paddingLeft: '100%',
}));

const Marquee: React.FC<MarqueeProps> = ({
  speed = 5,
  text,
  typographyStyle = {},
}) => {
  const sx = {
    ...typographyStyle,
  };

  return (
    <MarqueeContainer>
      <MarqueeText speed={speed}>
        <Typography component="span" sx={sx} variant="body1">
          {text}
        </Typography>
      </MarqueeText>
    </MarqueeContainer>
  );
};

export default Marquee;
